import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemsMutation
 * @since 1.0.0
 */
export const ImportSaleItemsMutation = gql `
  mutation ImportSaleItemsMutation($input: ImportSaleItemsInput!) {
    importSaleItems(input: $input)
  }
`;
